<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div style="display: inline-block; height:40px;">
                    <el-select v-model="queryForm.deptId" placeholder="请选择学校">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-input v-model="queryForm.title" placeholder="商品名称"></el-input>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-select v-model="queryForm.status" clearable placeholder="请选择状态">
                    <el-option
                        v-for="item in statuss"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
            <div style="display: inline-block; height:40px; float:right;">
                <el-button type="primary"  icon="el-icon-plus" @click="setAdd()">新增</el-button>
                <el-button type="primary" @click="exportExcel">导出Excel</el-button>
                <el-button type="danger"  v-if="currUserId == 1" @click="setNoticeUsers()">修改接收者</el-button>
                <el-button type="danger"  v-if="currUserId == 1" @click="setCopy()">复制</el-button>
            </div>
            
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                height="550"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                border default-expand-all
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="" label="商品图标"  :show-overflow-tooltip="true" width="90px" >
                    <template slot-scope="scope">
                        <div v-if="scope.row.iconUrl != null && scope.row.iconUrl != ''">
                            <el-popover
                                placement="right"
                                title=""
                                trigger="hover">
                                <img :src="scope.row.iconUrl" lazy="loading"
                                    style="max-height:250px; max-width:330px"/>
                                <img slot="reference" :src="scope.row.iconUrl"  lazy="loading" :alt="scope.row.iconUrl" style="max-height: 50px;max-width: 130px">
                            </el-popover>
                        </div>
                        <div v-else>
                            未上传
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="商品标题"  :show-overflow-tooltip="true" width="100px"></el-table-column>
                <el-table-column prop="twoTitle" label="商品简介"  :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="price" label="价格(金币)" width="80px"></el-table-column>
                <el-table-column prop="status" label="状态" width="80px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status == 1">
                           上架
                        </div>
                        <div v-else-if="scope.row.status == 2" style="color:red;">
                           下架
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="commonName" label="下单后接收者" :show-overflow-tooltip="true"  width="80px"></el-table-column>
                <el-table-column prop="" label="电商购买链接" width="100">
                     <template slot-scope="scope">
                        <div v-if="scope.row.commodityLinks != null && scope.row.commodityLinks != ''">
                            <a :href="scope.row.commodityLinks" target="_bank">点击进入</a>
                        </div>
                        <div v-else>
                            无
                        </div>
                     </template>
                </el-table-column>
                <el-table-column prop="orderNum" label="排序号" width="60"></el-table-column>
                <el-table-column fixed="right" label="操作" width="100px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button  @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button  @click.native.prevent="setUpdateContent(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改商品详情</span>
                        </el-button>
                        <el-button  v-if="scope.row.status == 1"
                            @click.native.prevent="setStatus(scope.row,2)"
                            type="text"
                            size="small"  style="color: red" >
                            下架
                        </el-button>
                        <el-button  v-if="scope.row.status == 2"
                            @click.native.prevent="setStatus(scope.row,1)"
                            type="text"
                            size="small" style="color: #387EE8;">
                            上架
                        </el-button>
                        <el-button style="color: red" @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!-- 新增/修改弹出框 -->
        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
        <!-- 编辑商品详情-->
        <div v-if="updateContentVisible">
            <updateContent ref="updateContent"></updateContent>
        </div>
        <!-- 设置商品复制 -->
        <div v-if="setCopyVisible">
            <setCopy ref="setCopy"></setCopy>
        </div>
        <!-- 修改接收者 -->
        <div v-if="setNoticeUsersVisible">
            <setNoticeUsers ref="setNoticeUsers"></setNoticeUsers>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import http from '../../../../common/http'; 
    import add from './Add.vue';
    import update from './Update.vue';
    import updateContent from './UpdateContent.vue';
    import setCopy from './SetCopy.vue';
    import setNoticeUsers from './SetNoticeUsers.vue';

    export default {
        name:"CommodityList",
        data(){
            return{
                menuName:"",
                loading:false,
                loadingText:"",

                addVisible:false,
                updateVisible:false,
                updateContentVisible:false,
                setCopyVisible:false,
                setNoticeUsersVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                queryForm:{
                    deptId: "",
                    status: "",
                    title: ""
                },
                form:{
                    id: "",
                    status: "",
                },
                currUserId:"",
                data:[],
                depts:[],
                statuss:[{
                    value: 1,
                    label: '上架'
                }, {
                    value: 2,
                    label: '下架'
                }]
            }
        },
        components: {
            add,update,updateContent,setCopy,setNoticeUsers
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
            this.getDeptData();
            //获取当前登录用户，然后当前用户不能编辑自己也不能删除自己
            this.currUserId=JSON.parse(sessionStorage.getItem('userinfo')).id;
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.queryForm.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                this.loadingText="数据加载中...";

                let url  = this.commodityListUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    deptId:this.queryForm.deptId,
                    title:this.queryForm.title,
                    status:this.queryForm.status,
                };
                // console.log(JSON.stringify(data));
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                       this.common.total=res.data.total;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }
                else{
                    return true;
                }
            },
            //新增界面
            setAdd(){
                this.addVisible=true;
                this.$nextTick(() => {
                    this.$refs['add'].init(this.queryForm.deptId);
                })
            },
            //修改界面
            setUpdate(data){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['update'].init(data);
                })
            },
            //修改商品详情界面
            setUpdateContent(data){
                this.updateContentVisible=true;
                this.$nextTick(() => {
                    this.$refs['updateContent'].init(data);
                })
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.commodityRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }
                else{
                    return true;
                }
            },
            handleSelectionChange(val){
                this.common.checkboxArr = [];
                for (let i = 0;i < val.length;i++){
                    this.common.checkboxArr.push(val[i].id);
                }
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            // 启用/停用
            setStatus(row,status){
                this.form.id = row.id;
                this.form.status=status;
                if(status == 1){
                    this.updateStatusSuccess();
                }else if(status == 2){
                    let msg="此操作将商品下架，导致该商品在移动端不能显示，是否继续？";
                    this.$commonFn.showConfirm2(msg,this.updateStatusSuccess);
                }
            },
            updateStatusSuccess(){
                let url  = this.commodityUpdateStatusUrl;
                let data = {
                    id:this.form.id,
                    status:this.form.status
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // 复制对象
            setCopy(){
                this.setCopyVisible=true;
                this.$nextTick(() => {
                    this.$refs['setCopy'].init(this.queryForm.deptId);
                })
            },
            // 修改接收者
            setNoticeUsers(){
                if(this.common.checkboxArr.length != 0){
                    let checkIdArr=new Array();
                    for(var i=0;i<this.common.checkboxArr.length;i++){
                        if(this.common.checkboxArr[i]!=1){
                            checkIdArr.push(this.common.checkboxArr[i]);
                        }
                    }

                    let ids =checkIdArr.join(",");
                    this.setNoticeUsersVisible=true;
                    this.$nextTick(() => {
                        this.$refs['setNoticeUsers'].init(this.queryForm.deptId, ids);
                    })
                }else{
                    this.$commonFn.showTip("请选择数据",2);
                }
            },
            exportExcel(){
                const maxCount = 65535
                if(this.common.total > maxCount){
                    let msg="导出数据超出"+maxCount+"条平台不支持，请缩小数据范围查询，然后再进行导出操作！"
                    this.$commonFn.showTip(msg,3)
                }else{
                    this.exportData()
                }
            },
            exportData(){
                this.loading=true;
                this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待";

                let url=this.commodityExportExcelUrl
                console.log("url:"+url);
                let param = new URLSearchParams();
                param.append('deptId', this.queryForm.deptId)
                param.append('title', this.queryForm.title)
                param.append('status', this.queryForm.status)

                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", '商品.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    console.log(error); 
                    this.loading=false;
                });
           }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/shop/wares/CommodityList.vue